import { createStore } from "redux";
import actionReducer from "./actionReducer";
import { composeWithDevTools } from "redux-devtools-extension";
const store = createStore(actionReducer, composeWithDevTools());

export default store;
